export enum ApiUrl {
  CsrfTokenApiUrl = "/api/csrf-token",
  ProductsApiUrl = "/api/products",
  ServicesApiUrl = "/api/services",
  ContactsApiUrl = "/api/contacts",
  ProductsImagesUrl = "/data/images/products",
  ServicesImagesUrl = "/data/images/services",
  CategoriesImagesUrl = "/data/images/categories",
  ContactsImagesUrl = "/data/images/contacts"
}

export enum ApiSendStatus {
  OK = "OK",
  ERROR = "ERROR",
  ERROR_TOO_MANY_ATTEMPTS = "ERROR_TOO_MANY_ATTEMPTS",
}